import MediaFile from './MediaFile';
import { MediaDimensions } from './types';

const NONE: MediaDimensions = {};

/** Web would have to decode the file to get these, so it reports none. */
const getMediaDimensions: (mediaFile: MediaFile) => MediaDimensions = () => NONE;

export default getMediaDimensions;
